import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import PermissionGrantId = com.eidu.sharedlib.entity.permission.PermissionGrantId

export type DeletePermissionGrantParameters = {
  id: PermissionGrantId
}

const deletePermissionGrant = async ({ id }: DeletePermissionGrantParameters): Promise<void> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants/${id.toString()}`,
    {
      method: 'DELETE',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from deletePermissionGrant endpoint`)
  })
}

export default deletePermissionGrant
